import React, { useState, useEffect, useMemo } from 'react';
import './scss/Hero.scss';
import HaikuComponent from './HaikuComponent';

const Hero: React.FC = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const titles = useMemo(() => [
    'Cloud Solution Architect',
    'Partner Solution Architect',
    'AI Platform Architect',
    'Infrastructure Architect',
    'Cloud Security Advisor',
    'Technical Workshop Facilitator'
  ], []);

  useEffect(() => {
    const currentTitle = titles[currentIndex];
    let charIndex = 0;
    
    const typeInterval = setInterval(() => {
      if (charIndex <= currentTitle.length) {
        setDisplayedText(currentTitle.slice(0, charIndex));
        charIndex++;
      } else {
        clearInterval(typeInterval);
        
        setTimeout(() => {
          const eraseInterval = setInterval(() => {
            if (charIndex > 0) {
              charIndex--;
              setDisplayedText(currentTitle.slice(0, charIndex));
            } else {
              clearInterval(eraseInterval);
              setCurrentIndex((prev) => (prev + 1) % titles.length);
            }
          }, 50);
        }, 2000);
      }
    }, 100);

    return () => clearInterval(typeInterval);
  }, [currentIndex, titles]);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProjects = () => {
    const element = document.getElementById('projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Hi, I'm <span className="text-accent">Riyasat Ali</span>
            </h1>
            {/* <HaikuComponent/> */}
            <h2 className="hero-subtitle">
              I'm a <span className="typing-text">{displayedText}</span>
              <span className="cursor">|</span>
            </h2>
            <p className="hero-description">
              I am a pre-sales focused Partner Solution Architect and senior technology leader with over 15 years of experience translating complex enterprise requirements into scalable, replicable cloud architectures. I specialize in secure AI platforms, cloud infrastructure, security governance, technical PoCs, and partner enablement across Azure, AWS, and hybrid environments.

            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={scrollToContact}>
                <i className="fas fa-envelope"></i>
                Get In Touch
              </button>
              <button className="btn-secondary" onClick={scrollToProjects}>
                <i className="fas fa-briefcase"></i>
                View My Work
              </button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="profile-card">
                <div className="profile-image" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src="/me.jpg"
                  alt="Riyasat Ali"
                  style={{
                  width: '230px',
                  height: '230px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  objectPosition: 'top',
                  
                  }}
                />
                </div>
              <div className="floating-elements">
                <div className="tech-icon tech-icon-1">
                  <i className="fas fa-brain"></i>
                </div>
                <div className="tech-icon tech-icon-2">
                  <i className="fab fa-microsoft"></i>
                </div>
                <div className="tech-icon tech-icon-3">
                  <i className="fab fa-aws"></i>
                </div>
                <div className="tech-icon tech-icon-4">
                  <i className="fab fa-docker"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
